:host {
  --aha-card-field--title-font-size: 0.875rem;
  display: inline-flex;
  padding: var(--spacer-05);
  margin: 0 var(--spacer-05);
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  align-items: center;
}

:host([nowrap]) {
  white-space: nowrap;
}

/* Force a consistent width on iconsZ */
slot[name='icon']::slotted(i),
slot[name='icon']::slotted(aha-icon) {
  color: var(--theme-tertiary-text);
  width: 1.5em;
  display: inline-block;
  text-align: center;
}

/* Add a gap after the icon if it's an image */
slot[name='icon']::slotted(img) {
  margin-right: 0.5ch;
}

/* We are overriding the link default behavior for the titles of aha-cards, the importants are necessary */
:host(.title-field) slot,
:host(.title-field) slot::slotted(*) {
  color: var(--theme-primary-text) !important;
  font-size: var(--aha-card-field--title-font-size);
  font-weight: 500;
}

:host(.title-field) slot::slotted(a:hover) {
  color: var(--aha-blue-500) !important;
  text-decoration: none !important;
}
